import React, { useState } from "react";
import { Link } from "react-router-dom";

const months = [
  {
    id: 1,
    name: "Mensual",
    months: "Pago mensual",//"3 meses",
    price: "11.80",
    total: "14",
    description: [
      // "-Monto mensual $11.8",
      // "-Primer pago $59",
      "-Monto anual $168",
      "-Seguridad SSL",
      "-Dominio Gratis",
      "-Vinculación dominio propio",
      "-Hosting gratis",
    ],
    isPromo: false,
    gt: "un mes",
  },
  {
    id: 2,
    name: "Trimestral",
    months: "Pago trimestral",//"3 meses",
    price: "11.80",
    total: "59",
    description: [
      // "-Monto mensual $11.8",
      // "-Primer pago $59",
      "-Monto anual $236",
      "-Seguridad SSL",
      "-Dominio Gratis",
      "-Vinculación dominio propio",
      "-Hosting gratis",
    ],
    isPromo: true,
    gt: "un mes",
  },
  // {
  //   id: 2,
  //   name: "Semestral",
  //   months: "Primer pago",//"6 meses",
  //   price: "10.80",
  //   total: "65",
  //   description: [
  //     // "-Monto mensual $10.8",
  //     // "-Primer pago $65",
  //     "-Ahorras $19 en el primer pago",
  //     "-Monto anual $149",
  //     "-Segundo pago de $84",
  //     "-Seguridad SSL",
  //     "-Dominio Gratis",
  //     "-Vinculación dominio propio",
  //     "-Hosting gratis",
  //   ],
  //   isPromo: true,
  //   gt: "tres meses",
  // },
  {
    id: 3,
    name: "Anual",
    months: "Pago anual",//"12 meses",
    price: "11.80",
    total: "130",
    description: [
      // "-Monto mensual $11.8",
      // "-Primer pago $130",
      "-Ahorras $106 anual",
      "-Monto anual $130",
      "-Seguridad SSL",
      "-Dominio Gratis",
      "-Vinculación dominio propio",
      "-Hosting gratis",
    ],
    isPromo: false,
    gt: "doce meses",
  },
];

function PriceBanner({ handleButtonClick }) {
  const [pricesFlag, setPricesFlag] = useState({ price2: true });
  const [selectedPrice, setSelectedPrice] = useState(months[1]);

  const priceClicked = (item) => {
    setPricesFlag({ ["price" + item.id]: true });
    setSelectedPrice(months[item.id - 1]);
    handleButtonClick("Planes", "clic en boton", item.gt);
  };

  return (
    <div className="price-list">
      <div className="title">
        <h2>¡Comienza en un Bizz!</h2>
        <p>
          Una tienda virtual con herramientas avanzadas de configuración y gestión de
          productos.
        </p>
      </div>
      <div className="body">
        {months.map((elem, index) => (
          <div
            className="month"
            key={index + "_" + elem.name}
            style={elem.isPromo ? { background: "#8163FF", color: "#FFFFFF" } : {}}
          >
            {elem.isPromo && <div className="promo">Promoción</div>}
            <div className="info">
              <h3 style={elem.isPromo ? { color: "#FFFFFF" } : {}}>{elem.name}</h3>
              <div className="option-price">
                <p className="price">${elem.total}</p>
                <p>{elem.months}</p>
                {elem.description.map((description, index) => (
                  <div className="description" key={index + "_description"}>
                    {description}
                  </div>
                ))}
              </div>
            </div>
            <Link
              to={"/nueva-tienda"}
              style={elem.isPromo ? { background: "#FFC700", color: "#8163FF" } : {}}
              onClick={() =>
                handleButtonClick("Planes", "clic en boton", "Comienza Bizz", elem.gt)
              }
            >
              Comenzar
            </Link>
          </div>
        ))}
      </div>
    </div>
    // <div
    //  className="feature-section-four flex justify-center items-center"
    //  id="plans"
    // >
    //  <div className="content-section flex flex-col justify-center items-center">
    //   <p className="title">¡Comienza en un Bizz!</p>
    //   <p className="subtitle">
    //    Una tienda virtual con herramientas avanzadas de configuración y gestión de
    //    productos.
    //   </p>
    //   <div className="months w-full">
    //    {months.map((item) => (
    //     <button
    //      key={item.name}
    //      className="month"
    //      style={
    //       pricesFlag["price" + item.id]
    //        ? { background: "#00FBC8", color: "#282828" }
    //        : { background: "#6D4EEF", color: "#BAA9FF" }
    //      }
    //      onClick={() => priceClicked(item)}
    //     >
    //      {item.months}
    //     </button>
    //    ))}
    //   </div>
    //   <div className="content-price flex flex-col justify-center items-center">
    //    <p className="title">Precio Total:</p>
    //    <p className="price">$ {selectedPrice.price} USD/mes</p>
    //    <p className="total-price">Total a pagar: $ {selectedPrice.total} USD</p>
    //    {selectedPrice?.discount && (
    //     <p className="discount">{selectedPrice.discount}</p>
    //    )}
    //    {selectedPrice?.text && <p className="discount">{selectedPrice.text}</p>}{" "}
    //   </div>
    //   <button className="p-0">
    //    <Link
    //     className="w-full"
    //     style={{ padding: "10px 5px", borderRadius: "30px" }}
    //     to={"/nueva-tienda"}
    //     onClick={() =>
    //      handleButtonClick("Planes", "clic en boton", "Comienza Bizz")
    //     }
    //    >
    //     {" "}
    //     Comenzar{" "}
    //    </Link>
    //   </button>
    //  </div>
    // </div>
  );
}

export default PriceBanner;
